export const isHttpsPresent = (url: string): boolean => {
  const httpRegex = /^http:\/\//i;
  const httpsRegex = /^https:\/\//i;

  return httpRegex.test(url) || httpsRegex.test(url);
};
